import React from "react";
import Box from "@mui/material/Box";
import { COLORS } from "../../theme/tokens";

const RAIL_STOPS = [
  { href: "#welcome", label: "Welkom" },
  { href: "#in-de-klas", label: "In de klas" },
  { href: "#freinet", label: "Freinet" },
  { href: "#school", label: "Onze school" },
  { href: "#ouders", label: "Ouders" },
  { href: "#nieuws", label: "Nieuws" },
  { href: "#contact-aanmelden", label: "Aanmelden" },
];

export default function SideRail() {
  return (
    <Box
      component="nav"
      aria-label="Verhaalroute snelnavigatie"
      sx={{
        position: "fixed",
        left: 18,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 30,
        display: { xs: "none", md: "grid" },
        gap: "9px",
      }}
    >
      {RAIL_STOPS.map((stop) => (
        <Box
          key={stop.href}
          component="a"
          href={stop.href}
          aria-label={stop.label}
          title={stop.label}
          sx={{
            width: 24,
            height: 24,
            display: "grid",
            placeItems: "center",
            borderRadius: "50%",
            "&::before": {
              content: '""',
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: "rgba(60, 143, 153, 0.65)",
              border: "2px solid #fff",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.18)",
              transition: "background-color 0.2s ease",
            },
            "&:hover::before, &:focus-visible::before": {
              backgroundColor: COLORS.blue,
            },
            "&:focus-visible": {
              outline: "3px solid #203033",
              outlineOffset: 2,
            },
          }}
        />
      ))}
    </Box>
  );
}
